<textarea [disabled]="options.disabled" [id]="id"></textarea>
